























































































































































































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { renderMedicineHtml } from "./medicineTextConverter";

interface ProductView {
  product_name: string;
  major_heading: string;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
}

interface MedicineView {
  yj_code: string;
  name: string;
  is_generic: boolean;
  unit: string;
  generic_name: string;
  category: string;
  indications: string;
  dosage: string;
  features: string;
  photo_file_name: string;
  sub_photo_file_names?: string[];
  products?: ProductView[];
}

@Component
export default class MedicineDetailDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: null }) medicine!: MedicineView | null;
  @Prop({ default: false }) isViewOnly!: boolean;

  private internalValue = false;
  private activeTab = 0;

  /** 内部で管理する表示対象（対応するお薬クリックで更新される） */
  private internalMedicine: MedicineView | null = null;

  /** 写真ナビゲーション */
  private activePhotoIndex = 0;

  /** メイン + サブ写真を結合したリスト */
  get allPhotos(): string[] {
    const photos: string[] = [];
    if (this.internalMedicine?.photo_file_name) {
      photos.push(this.internalMedicine.photo_file_name);
    }
    if (this.internalMedicine?.sub_photo_file_names) {
      photos.push(...this.internalMedicine.sub_photo_file_names);
    }
    return photos;
  }

  get activePhoto(): string | null {
    return this.allPhotos[this.activePhotoIndex] ?? null;
  }

  get productLeadIcon(): string {
    const name = this.currentProduct.product_name || "";
    const lead = name.charAt(0);
    const iconMap: Record<string, string> = {
      "●": "ic_daihyo",
      "○": "ic_kouhatsu_a",
      "★": "ic_shinyaku",
      "◎": "ic_ag_c"
    };
    const icon = iconMap[lead] || "ic_kouhatsu_b";
    return `/images/medicine/icon/${icon}.svg`;
  }

  get hasMultipleProducts(): boolean {
    return !!(
      this.internalMedicine &&
      this.internalMedicine.products &&
      this.internalMedicine.products.length > 1
    );
  }

  get currentProduct(): ProductView {
    if (
      this.internalMedicine &&
      this.internalMedicine.products &&
      this.internalMedicine.products.length > 0
    ) {
      return (
        this.internalMedicine.products[this.activeTab] ||
        this.internalMedicine.products[0]
      );
    }
    return {
      product_name: "",
      unit: this.internalMedicine?.unit || "",
      generic_name: this.internalMedicine?.generic_name || "",
      category: this.internalMedicine?.category || "",
      indications: this.internalMedicine?.indications || "",
      dosage: this.internalMedicine?.dosage || "",
      features: this.internalMedicine?.features || "",
      major_heading: ""
    };
  }

  @Watch("value")
  private onValueChanged(val: boolean) {
    this.internalValue = val;
    if (val) {
      this.internalMedicine = this.medicine;
      this.activeTab = 0;
      this.activePhotoIndex = 0;
    }
  }

  @Watch("medicine")
  private onMedicineChanged(val: MedicineView | null) {
    if (this.internalValue) {
      this.internalMedicine = val;
      this.activeTab = 0;
    }
  }

  @Emit("input")
  private emitInput(val: boolean) {
    return val;
  }

  @Emit("register")
  private emitRegister(medicine: MedicineView) {
    return medicine;
  }

  @Emit("open-product-detail")
  private emitOpenProductDetail(productId: string) {
    return productId;
  }

  private renderHtml(text: string): string {
    return renderMedicineHtml(text);
  }

  private onContentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.tagName === "A" && target.classList.contains("medicine-ref")) {
      event.preventDefault();
      const productId = target.getAttribute("data-product-id");
      if (productId) {
        this.close();
        this.emitOpenProductDetail(productId);
      }
    }
  }

  private prevPhoto() {
    if (this.activePhotoIndex > 0) this.activePhotoIndex--;
  }

  private nextPhoto() {
    if (this.activePhotoIndex < this.allPhotos.length - 1)
      this.activePhotoIndex++;
  }

  private close() {
    this.internalValue = false;
    this.emitInput(false);
  }

  private register() {
    if (this.internalMedicine) {
      this.emitRegister(this.internalMedicine);
    }
  }
}
